export default __webpack_public_path__ + "static/media/ic-bin-blue-24-px.478282b4.svg";